import { Footer } from 'antd/es/layout/layout'
import React, { useRef } from 'react'
import smallLogo from 'assets/images/allin1logo.png';
import { useNavigate } from 'react-router-dom';
import { blindList, toAwning, toBlind, toCurtain, toPlantation, toRollerShutter } from './ProductCollection';
import { useIsVisible } from './useIsVisible';
export default function ShopFrontFooter() {
    const navigate = useNavigate()
    const ref3 = useRef<HTMLDivElement>(null);
    const isVisible3 = useIsVisible(ref3);

    const getDisplayDelay = (index: number) =>{
        return String((index+1)*500) + 'ms'
    }
  return (
    <Footer ref={ref3} className={` bg-white border-solid border border-gray-200 hedvig-letters-sans-regular  transition-all duration-500 ease-in ${isVisible3 ? "opacity-100" : "translate-y-5 opacity-0"}`}>
            <div className=' m-auto h-fit flex flex-col md:flex-col gap-10 lg:flex-row lg:gap-20 '>
                <div className='flex flex-col w-full md:w-1/2 justify-center items-center sm:items-start sm:justify-start  '>
                    <div className="flex mt-2 mb-5">
                        
                        <img  style={{maxHeight:'250px'}} src={smallLogo} />
                    </div>
                  
                    
                </div>
                <div className='h-fit grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-3 gap-10 lg:flex-row lg:gap-20 w-full md:w-1/2'>
                    <div className='flex flex-col'>
                        <span className=' text-lg text-neutral-600 mb-2'>Products</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform'
                            onClick={()=>{navigate('/products/awnings')}}
                        >Awnings</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform'
                            onClick={()=>{navigate('/products/blinds')}}
                        >Blinds</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform'
                             onClick={()=>{navigate('/products/curtains')}}
                        >Curtains</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform'
                            onClick={()=>{navigate('/products/plantations')}}
                        >Plantation Shutters</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform'
                            onClick={()=>{navigate('/products/roller-shutters')}}
                        >Roller Shutters</span> 
                        
                    </div>
                    <div className='flex flex-col'>
                        <span className=' text-lg text-neutral-600 mb-2'>Support</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform'>FAQ</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform' onClick={()=>{navigate('/privacy',{state:toAwning})}}>Privacy Policy</span>
                        
                        
                    </div>
                    <div className='flex flex-col'>
                        <span className=' text-lg text-neutral-600 mb-2' >About Us</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform' onClick={()=>{navigate('/contact')}}>Contact</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform' onClick={()=>{navigate('/contact')}}>Store Location</span>
                        <span className='font-medium text-xl text-black hover:underline hover:-translate-y-1 duration-300 transition-transform' onClick={()=>{navigate('/contact')}} >Free Quotation</span>
                        
                        
                    </div>
                    {/* <div className='flex flex-col'>
                    <span className=' text-lg text-neutral-600 mb-2'>Opening Hours</span>
                    <span className='font-medium text-xl text-black  w-full'>Mon - Sat: 8am - 5pm</span>
                    <span className='font-medium text-xl text-black  w-full'>Sunday: Closed</span>
                        
                        
                    </div> */}
                    
                </div>
                
                
                
            </div>
            {/* <div className='overflow-hidden rounded-2xl m-auto' style={{ width: 225}} >
                    <img
                        style={{width:225}}
                        className="hover:scale-110  duration-500 transition-transform"
                        alt=""
                        src="https://products-images-source.s3.ap-southeast-2.amazonaws.com/Australian-Made.png"
               
                    />
                </div> */}
        </Footer>)
}
